/**
 * Icon size tokens, in rem so they track the 50.782% root font-size like every
 * text token does. Sizing an icon in px next to text sized in rem is what made
 * cap heights diverge across messaging and the shared chrome — a 12px glyph
 * beside a 1rem label is ~48% taller than it looks in the design.
 *
 * Pick the token that matches the text the icon sits beside.
 */
/* eslint-disable sort-keys -- ordered smallest to largest, not alphabetically */
export const iconSizes = {
  /** ~13px — inline with caption / body2 text */
  sm: '1.6rem',
  /** ~16px — inline with body1 / subtitle1 text, standard toolbar glyph */
  md: '2rem',
  /** ~19.5px — standalone affordances, tile and card icons */
  lg: '2.4rem',
  /** ~29px — page-level navigation glyphs */
  xl: '3.6rem',
} as const
/* eslint-enable sort-keys */
